module.exports = __webpack_public_path__ + "img/step3.ee71bb33.png";